import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c152091c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-content"
}, "Bulk edit listings", -1));
const _hoisted_3 = {
  class: "body"
};
const _hoisted_4 = {
  class: "instruction-section"
};
const _hoisted_5 = {
  class: "instruction-list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "instruction"
}, " Ensure listing selection in table is correct. "), /*#__PURE__*/_createElementVNode("div", {
  class: "instruction",
  style: {
    "font-weight": "600"
  }
}, " Listings cannot be added to template once generated ")], -1));
const _hoisted_7 = {
  key: 0,
  class: "download-template-btn downloading"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "download-btn-title"
}, " Generating Google Sheet template… ", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "download-btn-title"
}, " Download Google Sheet template ", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "instruction"
}, " Review the guidelines below, then edit template (white cells) ")], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "instruction"
}, " Download template as CSV and upload it below ")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Upload CSV File", -1));
const _hoisted_13 = {
  class: "upload-wrapper"
};
const _hoisted_14 = {
  class: "content"
};
const _hoisted_15 = {
  class: "text"
};
const _hoisted_16 = {
  key: 1,
  class: "text-body"
};
const _hoisted_17 = {
  key: 2,
  class: "file-name"
};
const _hoisted_18 = {
  key: 3,
  class: "uploading-progres"
};
const _hoisted_19 = {
  class: "guidelines"
};
const _hoisted_20 = {
  class: "guidelines-title"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "BULK EDIT TEMPLATE guidelines", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "body"
}, [/*#__PURE__*/_createElementVNode("ul", {
  style: {
    "list-style-type": "circle"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline-label blue"
}, "Edit white cells only"), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, " Template contains essential data for the proper execution of the process. Therefore, do not edit grey cells ")])]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline-label blue"
}, "Do not add rows"), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, " It will trigger technical issues during upload. "), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, " If listings are missing, go back to the platform, update table filters to include them and download a new template. "), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, " NB: Listing creation is not supported by this process. ")])]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline-label blue"
}, " Review file before upload "), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, " To ease final checks, conditional formatting is set up on editable columns: "), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-alert red"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "alert-label red"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "square red"
}), /*#__PURE__*/_createElementVNode("div", null, "Attribute is not compliant with Amazon guidelines")]), /*#__PURE__*/_createElementVNode("div", {
  class: "alert-content"
}, " Content exceeds the maximum char limit allowed by Amazon. This listing update will automatically be refused by Amazon when pushed. This will block file upload. ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-alert yellow"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "alert-label yellow"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "square yellow"
}), /*#__PURE__*/_createElementVNode("div", null, "Attribute has been deleted")]), /*#__PURE__*/_createElementVNode("div", {
  class: "alert-content"
}, " Current Omny content won't be accessible after upload. ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-alert blue"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "alert-label blue"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "square blue"
}), /*#__PURE__*/_createElementVNode("div", null, "Attribute has been updated")]), /*#__PURE__*/_createElementVNode("div", {
  class: "alert-content"
}, " This attribute will be updated in Omny database after upload. ")])])]), /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "guideline-label red"
}, " Upload replaces Omny latest version available with file content "), /*#__PURE__*/_createElementVNode("div", {
  class: "guideline-content"
}, [/*#__PURE__*/_createTextVNode(" Only listings included in the file are impacted. "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" Editions made directly in the application after template generation will be overriden during upload. Avoid making content changes between template generation and file upload. Otherwise, update Google Sheet accordingly or regenerate a new template after in-app edition. ")])])])])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_right_pane_layout = _resolveComponent("right-pane-layout");
  return _openBlock(), _createBlock(_component_right_pane_layout, {
    modelValue: $options.modal,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $options.modal = $event),
    onSubmit: _cache[8] || (_cache[8] = () => {
      $options.modal = false;
    }),
    okOnly: "true",
    class: "seo-bulk-modal"
  }, {
    title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_app_icon, {
      icon: "bulk-btn"
    }), _hoisted_2])]),
    ok: _withCtx(() => [_createTextVNode(" Close ")]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ol", _hoisted_5, [_hoisted_6, _createElementVNode("li", null, [$data.isDownloading ? (_openBlock(), _createElementBlock("div", _hoisted_7, [$data.isDownloading ? (_openBlock(), _createBlock(_component_b_spinner, {
      key: 0,
      class: "isDownloading",
      small: ""
    })) : _createCommentVNode("", true), _hoisted_8])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "download-template-btn",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.downloadBulkTemplate && $options.downloadBulkTemplate(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "ic-arrow-upward"
    }), _hoisted_9]))]), _hoisted_10, _hoisted_11])]), _createElementVNode("div", {
      class: "upload-file-section",
      onDrop: _cache[3] || (_cache[3] = _withModifiers((...args) => $options.handleDrop && $options.handleDrop(...args), ["prevent"])),
      onDragover: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.handleDragOver && $options.handleDragOver(...args), ["prevent"])),
      onDragenter: _cache[5] || (_cache[5] = (...args) => $options.dragEnter && $options.dragEnter(...args)),
      onDragleave: _cache[6] || (_cache[6] = (...args) => $options.dragLeave && $options.dragLeave(...args))
    }, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_app_icon, {
      icon: "bulk-upload"
    }), (_openBlock(), _createElementBlock("input", {
      type: "file",
      ref: "nativeFileInput",
      class: "d-none",
      onChange: _cache[1] || (_cache[1] = (...args) => $options.handleFileChange && $options.handleFileChange(...args)),
      accept: ".csv",
      key: $data.inputKey
    }, null, 32)), _createElementVNode("div", _hoisted_15, [!$data.loading ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "text-label",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.triggerNativeFileInput && $options.triggerNativeFileInput(...args))
    }, " Choose your file ")) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Supported file format: CSV ")) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString($data.fileName), 1)) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Uploading...")) : _createCommentVNode("", true)])])])], 32), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_app_icon, {
      icon: "bulk-guideline"
    }), _hoisted_21]), _hoisted_22])])]),
    _: 1
  }, 8, ["modelValue"]);
}